(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product-category-product', {
            parent: 'entity',
            url: '/product-category-product',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.productCategoryProduct.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-category-product/product-category-products.html',
                    controller: 'ProductCategoryProductController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productCategoryProduct');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-category-product-detail', {
            parent: 'entity',
            url: '/product-category-product/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.productCategoryProduct.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-category-product/product-category-product-detail.html',
                    controller: 'ProductCategoryProductDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productCategoryProduct');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProductCategoryProduct', function($stateParams, ProductCategoryProduct) {
                    return ProductCategoryProduct.get({id : $stateParams.id});
                }]
            }
        })
        .state('product-category-product.new', {
            parent: 'product-category-product',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-category-product/product-category-product-dialog.html',
                    controller: 'ProductCategoryProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sortOrder: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('product-category-product', null, { reload: true });
                }, function() {
                    $state.go('product-category-product');
                });
            }]
        })
        .state('product-category-product.edit', {
            parent: 'product-category-product',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-category-product/product-category-product-dialog.html',
                    controller: 'ProductCategoryProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductCategoryProduct', function(ProductCategoryProduct) {
                            return ProductCategoryProduct.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-category-product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product-category-product.delete', {
            parent: 'product-category-product',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-category-product/product-category-product-delete-dialog.html',
                    controller: 'ProductCategoryProductDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProductCategoryProduct', function(ProductCategoryProduct) {
                            return ProductCategoryProduct.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-category-product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
